import { render, staticRenderFns } from "./ChangePayerPopup.vue?vue&type=template&id=ff6c48b6&scoped=true&"
import script from "./ChangePayerPopup.vue?vue&type=script&lang=js&"
export * from "./ChangePayerPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6c48b6",
  null
  
)

export default component.exports